import { valueIncludedOrEqual } from "@/utils/helpers";
import { removeQualifying } from "@/utils/questions";
import { faXmark } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Text, Select, Flex, ActionIcon } from "@mantine/core";

import { AddConditionButton } from "./add-condition-button";
import {
  QuestionStateSetter,
  QuestionType,
  ReviewPageDraftQuestion,
} from "@/types/screener-builder";
import { type Maybe, YesNo } from "@/types/utils";

// Export validation function for use in BasicQuestionForm
export const yesNoRulesValid = (
  question: ReviewPageDraftQuestion<QuestionType.YesNo>,
): boolean => {
  if (!question.isQualifying) {
    return true;
  }

  return valueIncludedOrEqual(
    [YesNo.Yes, YesNo.No],
    question.validationRules?.yesNoRule,
  );
};

interface YesNoValidationRulesProps {
  question: ReviewPageDraftQuestion<QuestionType.YesNo>;
  setQuestion: QuestionStateSetter<QuestionType.YesNo>;
}

export const YesNoValidationRules = ({
  question,
  setQuestion,
}: YesNoValidationRulesProps) => {
  const hasYesNoRule = question.validationRules?.yesNoRule !== undefined;

  const handleAddCondition = () => {
    setQuestion({
      ...question,
      isQualifying: true,
      validationRules: {
        yesNoRule: YesNo.Yes,
      },
    });
  };

  if (!hasYesNoRule) {
    return <AddConditionButton onClick={handleAddCondition} />;
  }

  return (
    <Flex align="center" gap="xs" className="mt-2">
      <Text size="sm" fw={400}>
        Answer is
      </Text>
      <Select
        allowDeselect={false}
        className="w-[120px]"
        data={[
          { value: YesNo.Yes, label: "Yes" },
          { value: YesNo.No, label: "No" },
        ]}
        value={question.validationRules?.yesNoRule}
        onChange={(value) => {
          setQuestion({
            ...question,
            validationRules: {
              ...question.validationRules,
              yesNoRule: value as Maybe<YesNo>,
            },
          });
        }}
      />
      <ActionIcon
        variant="transparent"
        size="xs"
        onClick={() => setQuestion(removeQualifying(question))}
      >
        <FontAwesomeIcon icon={faXmark} />
      </ActionIcon>
    </Flex>
  );
};
